import PropTypes from "prop-types";

export default function AlertBox({ text, color }) {
  const colors = {
    mint: "bg-mint",
    red: "bg-red",
  };

  return (
    <div
      className={`rounded-md ${colors[color]} p-sm w-full`}
      data-testid="container-div"
    >
      <div className="flex">
        <div
          className="align-center gn-text-sm text-white p-sm"
          data-testid="text-container"
        >
          <p className="w-full gn-word-break">{text}</p>
        </div>
      </div>
    </div>
  );
}

AlertBox.propTypes = {
  text: PropTypes.string.isRequired,
  color: PropTypes.oneOf(["red", "mint"]),
};

AlertBox.defaultProps = {
  color: "red",
};
